import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { QnSbnService } from '../services/qn-sbn-service.service';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnDataServiceService } from '../services/qn-sbn-data-service.service';
import { CommonModule } from '@angular/common';
import * as XLSX from 'xlsx';
import { snackbarService } from '@one/web-components';
import { FileFormatDialogComponent } from '../notification/file-format-dialog/file-format-dialog.component';

@Component({
  selector: 'dl-rexis-sap-dialog',
  standalone: true,
  imports: [OneWebComponentsAngularModule,CommonModule,ReactiveFormsModule,FileFormatDialogComponent,FormsModule],
  templateUrl: './rexis-sap-dialog.component.html',
  styleUrls: ['./rexis-sap-dialog.component.scss']
})

export class RexisSapDialogComponent implements OnInit, OnDestroy {
  @Output() dialogClose = new EventEmitter<any>();
   @Input() data: any;
  public previousMapptedData: any = [];
  public mappedData: any = [];
  public countryCode: string = "";
  public materialNo: string  = "";
  public reagentMaterialNo: any  = [];
  public batchNo: any  = [];
  public dateFrom: Date|null = null;
  public dateTo: Date|null = null;
  public contactRole: string = "";
  public records: string = "";
  public contactAttrType: string  = "any";
  public contactAttrValue: string = "";
  public title: string = "Contacts";
  public accountsSource: string = "none";
  public contactsSource: string = "none";
  public showAccountsByIntrument: boolean = false;
  public showAccountsByShipments: boolean = false; 
  public showContactsByInstrument: boolean = false;
  public showContactsBySafetyAndQuality: boolean = false;
  public requestEnabled: boolean = false;
  // public countryCodes = ['GB','IE','AR','CA','ES','US','PY','UY','PT','BR','DO','IN','MX','PT','NI','HR','GT','CZ','CO','CL','PA','AT']
  public countryCodes: any = [];
  public countryCodeFC = new FormControl(this.countryCode, [Validators.required]);
  public affAccFC = new FormControl(this.accountsSource);
  public instruMatFC = new FormControl(this.materialNo, [Validators.required]);
  public batchNumFC = new FormControl(this.batchNo);
  public datepickeFromFC = new FormControl(this.dateFrom, [Validators.required]);
  public datepickeToFC = new FormControl(this.dateTo, [Validators.required]);
  public contactFC = new FormControl(this.contactsSource);
  public attTypFC = new FormControl(this.contactAttrType);
  public attValFC = new FormControl(this.contactAttrValue);
  public contRolFC = new FormControl(this.contactRole);
  public notificationData: any;
  public selectedData: any = [];
  public isDisabled: boolean = false;
  public downloadVisible: boolean = false;
  public cancelled: boolean = false;
  public instrumentStatus: string = "none";
  public instrumentStatusFC = new FormControl(this.instrumentStatus);
  public shipPartnerRole: any = ["all"];
  public shipPartnerRoleFC = new FormControl(this.shipPartnerRole)
  public allRoles = ["ag", "re", "rg", "sp", "y1", "y2", "we"];
  public allSelected = false;
  public allShipSelected = false;
  public checked: boolean = false;
  public instrumentMaterialNumber: any = [];
  public instrumentMaterials: any = [];
  public reagentMaterialBatchNumber: any =[];
  public materialBatchNo : any = [];
  public materialBatchNoValue : any = [];
  public reagentMaterialNoValue: any = [];
  public batchVal: any = [];

  constructor(
    public  QnSbnService: QnSbnService,
    public  qnSbnDataService: QnSbnDataServiceService,
    public  changeDetector: ChangeDetectorRef,
  ) { }

   ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      const incoming = changes['data'].currentValue;
      console.log('d----', incoming);
    }
  }

  public ngOnInit(): void {
    this.qnSbnDataService.hideActionBar$.next(true);
    
    this.qnSbnDataService.mappingData$.subscribe(
      res => {
        if(!this.qnSbnDataService.isEmpty(res)){
          this.notificationData = res;

          this.countryCode = this.notificationData.localNotificationId.Country;
          this.countryCodeFC.patchValue(this.countryCode);
          this.countryCodes.push(this.countryCode);
        }
      
      } 
    );
    if(!this.countryCode){
      this.snackBarMessage('alarm','Country code is unavailable. Please reopen the notification again');
     
    }
    this.addInstrumentField();
    this.addReagentBatchField();
    this.shipPartnerRoleFC.setValue([...this.allRoles]);
  }

  public ngOnDestroy(): void {
    this.qnSbnDataService.hideActionBar$.next(false);
  }

  public delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public async request() {
    this.isDisabled = true;
    this.previousMapptedData = this.mappedData;
    this.mappedData = [];
    this.records = "Requesting data...";
    try
    {
      let allCompleted = false;
      const filteredInstrumentMaterialNumber = this.instrumentMaterialNumber.filter(val => val && val.trim() !== '');

      const resForTaskId = await this.QnSbnService.getRexSapTaskId(
        this.countryCode, 
        this.accountsSource,
        this.contactsSource,
        filteredInstrumentMaterialNumber,
        this.reagentMaterialNoValue,
        this.materialBatchNoValue,
        //this.batchVal,
        this.dateFrom, 
        this.dateTo,
        (this.contactAttrType == "any" ? "" : this.contactAttrType),
        this.contactAttrValue,
        this.contactRole,
        this.instrumentStatus,
        this.shipPartnerRole
      );
      
      if(resForTaskId.statusCode === 202){

        while (!allCompleted && !this.cancelled) {
  
          await this.delay(4000);
          
          const resForData = await this.QnSbnService.getRexSapPolling(resForTaskId.body.taskId);
          
          if(resForData.statusCode === 200){

            allCompleted = resForData?.body?.allCompleted;

            const overallProgress = resForData?.body?.overallProgress;
            
            const rexSapData = resForData?.body?.finalResult || [];
    
            this.mappedData = this.joinData(rexSapData, this.previousMapptedData);
            
            if (this.mappedData != null && this.mappedData.length > 0) {
              this.mappedData.forEach((item: any) =>{
                item.checked = item.erpAccountNo && item.accountName && item.contactEmail;
              });
              this.selectedData = this.mappedData.filter((item: any) => item.checked);
            }

            if(allCompleted && overallProgress === '100.00' && rexSapData.length > 0){
              this.records = 'Completed';
              this.isDisabled = false;
            }else if(allCompleted && (overallProgress === '100.00' || overallProgress === '100') && (!rexSapData || rexSapData.length === 0)){
              this.isDisabled = false;
              this.records = 'No Data Found';
            }else{
              this.records = `Progress is ${overallProgress}%`;
            }
            this.changeDetector.detectChanges();

          }else{
            this.isDisabled = false;
            this.records = "Error occurred";
            allCompleted = resForData?.body?.allCompleted || true;
            this.snackBarMessage('alarm','Please request again later');
          
          }
          
        }
      }else{
        this.isDisabled = false;
        this.records = "Error occurred";
        this.snackBarMessage('alarm','Please request again later');
      }
    }
    catch (error) {
      this.isDisabled = false;
      this.records = "Error occurred";
      if(error.status === 400){
        this.snackBarMessage('alarm','No Sales Organization ID has been defined for your user group. Please contact the P&SC team to set one.');
      }else{
        this.snackBarMessage('alarm','Please request again later');
      }
    }
  }

  public clear() {
    this.mappedData = [];
    this.records = "";
    this.isDisabled = false;
  }

  public joinData(data: any, previousData: any) : any {
    if (previousData == null || previousData.length == 0){
      data.sort((a: any, b: any) => {
        if (a.accountName < b.accountName) return -1;
        if (a.accountName > b.accountName) return 1;
        if (a.contactName < b.contactName) return -1;
        if (a.contactName > b.contactName) return 1;
        return 0;
      });
      return data;
    } 

    // Create a copy of previous data
    let result = previousData.map((item: any) => {
      return { ...item };
    });

    // unique values are pushed from data to result
    data.forEach((item: any) => {
      const existingItem = result.some(
        (resultItem: any) =>{
          return resultItem?.crmAccountNo == item?.crmAccountNo
          && resultItem?.erpAccountNo == item?.erpAccountNo
          && resultItem?.accountName == item?.accountName 
          && resultItem?.contactName == item?.contactName
          && resultItem?.contactEmail == item?.contactEmail 
          && resultItem?.contactRole == item?.contactRole
          && resultItem?.safetyAndQuality?.qualityNotification == item?.safetyAndQuality?.qualityNotification
          && resultItem?.safetyAndQuality?.safetyBoardNotification == item?.safetyAndQuality?.safetyBoardNotification
          && resultItem?.safetyAndQuality?.supportNotification == item?.safetyAndQuality?.supportNotification
        } 
      );
      
      if (!existingItem) {
        result.push(item);
      }
    });

    // Order by accountName and contactName
    result.sort((a: any, b: any) => {
      if (a.accountName < b.accountName) return -1;
      if (a.accountName > b.accountName) return 1;
      if (a.contactName < b.contactName) return -1;
      if (a.contactName > b.contactName) return 1;
      return 0;
    });

    return result;
  }

  public onCountryCodeValueChange(event: any) {
    this.countryCode = event;
    this.requestEnabled = this.isRequestEnabled();
  }

  public onMaterialNoValueChange(event: any, i) {
    let value = '';
    if (event && event.target && event.target.value !== undefined) {
      value = event.target.value.trim();
    } else if (event && event.detail !== undefined) {
      value = (event.detail || '').toString().trim();
    } else if (typeof event === 'string') {
      value = event.trim();
    }
    
    this.materialNo = value;
    this.instrumentMaterialNumber[i] = value || null;
    
    this.requestEnabled = this.isRequestEnabled();
  }


  public onDateFromValueChange(event: any) {
    let value: any = null;
    if (event && event.detail) {
      value = event.detail;
    } else if (event && event.target && event.target.value) {
      value = event.target.value;
    }
    if (value) {
      this.dateFrom = value instanceof Date ? value : new Date(value);
    } else {
      this.dateFrom = null;
    }
    this.requestEnabled = this.isRequestEnabled();

    if(this.dateFrom && this.dateTo && this.dateFrom > this.dateTo){
      this.datepickeToFC.reset();
      this.dateTo = null;
      this.clearButton('datepickeToFC');
    }
  }

  public onDateToValueChange(event: any) {
    let value: any = null;
    if (event && event.detail) {
      value = event.detail;
    } else if (event && event.target && event.target.value) {
      value = event.target.value;
    }
    if (value) {
      this.dateTo = value instanceof Date ? value : new Date(value);
    } else {
      this.dateTo = null;
    }
    this.requestEnabled = this.isRequestEnabled();
  }

  public onAccountsSourceValueChange(event: any) {
    if (Array.isArray(this.affAccFC.value)) {
      this.affAccFC.patchValue(this.affAccFC.value[0]);
    }
    console.log("aa",this.affAccFC.value);
    
    const newValues = event.detail ? event.detail[0] : event; // fallback to event if detail is missing
    this.accountsSource = newValues;
    console.log("account", this.accountsSource);
    
    this.showAccountsByIntrument = this.accountsSource == "instrument";
    this.showAccountsByShipments = this.accountsSource == "shipments";

    if(this.showAccountsByShipments){
      const today = new Date();
      const thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(today.getDate() - 30);
      const thirtyDaysAgoString = thirtyDaysAgo.toISOString().split('T')[0];
      this.datepickeFromFC.patchValue(thirtyDaysAgo);
      this.datepickeToFC.patchValue(new Date());
      this.dateFrom = new Date(thirtyDaysAgoString);
      this.dateTo = new Date();
      this.instrumentMaterials = [{ control: new FormControl('') }];
      this.instrumentMaterialNumber = [];
      this.shipPartnerRoleFC.setValue([...this.allRoles]);
      this.shipPartnerRole = "all";
      this.instruMatFC.reset();
      this.materialNo = '';

      this.instrumentStatusFC.setValue("none");
      this.instrumentStatus = "none";
    }

    if(this.showAccountsByIntrument){
      this.reagentMaterialNo = [];
  
      // this.batchNumFC.reset();
      // this.batchNo = '';

      this.datepickeFromFC.reset();
      this.dateFrom = null;

      this.datepickeToFC.reset();
      this.dateTo = null;

      this.shipPartnerRoleFC.reset();
      this.shipPartnerRole = [];

      this.reagentMaterialBatchNumber = [];
      this.reagentMaterialNo = [];
      this.materialBatchNo = [];
      this.addReagentBatchField();
      this.reagentMaterialNoValue = '';
      this.materialBatchNoValue = '';

      this.instrumentStatusFC.setValue("none");
      this.instrumentStatus = "none";
    }

    this.requestEnabled = this.isRequestEnabled();
  }

  public onContactsSourceValueChange(event: any) {
    if (Array.isArray(this.contactFC.value)) {
      this.contactFC.patchValue(this.contactFC.value[0]);
    }
    const newValue = event.detail ? event.detail[0] : event; // fallback to event if detail is missing
    this.contactsSource = newValue;
    
    this.showContactsByInstrument = this.contactsSource == "instrument";
    this.showContactsBySafetyAndQuality = this.contactsSource == "safetyAndQuality";
    
    if(this.showContactsBySafetyAndQuality){
      if(!this.showAccountsByIntrument){
        this.instruMatFC.reset();
        this.materialNo = '';
      }

      this.contRolFC.reset();
      this.contactRole = '';
      
      if(!this.showAccountsByIntrument){
        this.instrumentStatusFC.setValue("none");
        this.instrumentStatus = "none";
      }
    }

    if(this.showContactsByInstrument){
      this.attTypFC.reset();
      this.contactAttrType = "any";
      
      this.attValFC.reset();
      this.contactAttrValue = "";
  
      this.contRolFC.reset();
      this.contactRole = '';

      if(!this.showAccountsByIntrument){
        this.instrumentStatusFC.setValue("none");
        this.instrumentStatus = "none";
      }
    }

    this.requestEnabled = this.isRequestEnabled();
  }

  public onInstrumentStatusChange(event:any){
    let newValue = "none";
    if (event && event.detail && event.detail.length > 0) {
      newValue = event.detail[0];
    } else if (event && typeof event === 'string') {
      newValue = event;
    }
    this.instrumentStatus = newValue;
    this.instrumentStatusFC.setValue(newValue);
  }

  public onContactAttrTypeValueChange(event: any) {
    let newValue = "any";
    if (event && event.detail && event.detail.length > 0) {
      newValue = event.detail[0];
    } else if (event && typeof event === 'string') {
      newValue = event;
    }
    this.contactAttrType = newValue;
    this.attTypFC.setValue(newValue);
  }

  public onContactAttrValueValueChange(event: any) {
    this.contactAttrValue = event.target.value;
  }

  public onContactRoleValueChange(event: any) {
    this.contactRole = event.target.value;
  }

  private isRequestEnabled() {
    if (this.countryCode == "") return false;
    if (this.accountsSource == "none" && this.contactsSource == "none") return false;
    if (this.accountsSource == "instrument" && this.instrumentMaterialNumber == "") return false;
    if (this.accountsSource == "shipments" && this.reagentMaterialNo == "" && this.materialBatchNo == "") return false;
    if (this.accountsSource == "shipments" && !this.dateFrom) return false;
    if (this.accountsSource == "shipments" && !this.dateTo) return false;
    if (this.contactsSource == "instrument" && this.instrumentMaterialNumber == "") return false;
    return true;
  }

  public onCheckValueChange(event: any, item: any) {
    item.checked = event.checked;
    if(item.checked === true){
      this.selectedData.push(item);
    }
    else if(item.checked === false){
      this.selectedData.pop(item);
    }else{
      return;
    }
  }

  public dateToFilter = (d: Date | null): boolean => {
    const dateTo = d || new Date();
    return dateTo >= this.dateFrom;
  }

  public onCancel(): void {
    this.cancelled = true;
    this.dialogClose.emit('cancel');
   
  }

  public onImport(): void {
    this.dialogClose.emit(this.selectedData);
  }

  public clearButton(id: any){
    const input = document.getElementById(id);
    if(id === 'datepickeFromFC' || id === 'datepickeToFC'){
      const dateChangeEvent = new Event('dateChange', { bubbles: true });
      input.dispatchEvent(dateChangeEvent);
    }else if(id.startsWith("reagentMatFC") || id.startsWith("batchNumFC") || id.startsWith("instruMatFC")){
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
    }else{
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
    }
  }

  public clearChildValue(filter){
    if(filter === 'affAccFC'){
      this.accountsSource = "none";
      if(this.showAccountsByIntrument && this.affAccFC.value === 'instrument'){
        this.instruMatFC.reset();
        this.materialNo = '';
      }

      this.reagentMaterialNo = '';

      this.batchNumFC.reset();
      this.batchNo = '';

      this.datepickeFromFC.reset();
      this.dateFrom = null;

      this.datepickeToFC.reset();
      this.dateTo = null;

      this.requestEnabled = this.isRequestEnabled();
    }
    if(filter === 'contactFC'){
      this.contactsSource = "none";

      if(((!this.showAccountsByIntrument && this.showContactsByInstrument) || this.affAccFC.value === null ) && this.contactFC.value === 'instrument'){
        this.instruMatFC.reset();
        this.materialNo = '';
      }

      this.attTypFC.reset();
      this.contactAttrType = "any";
      
      this.attValFC.reset();
      this.contactAttrValue = "";

      this.contRolFC.reset();
      this.contactRole = '';

      this.requestEnabled = this.isRequestEnabled();
    }
  }

  public addInstrumentField(){
    this.instrumentMaterials.push({ control: new FormControl('', [Validators.required]) });
  }

  public removeInstrumentField(index){
    if (this.instrumentMaterials.length > 1) {
      this.instrumentMaterials.splice(index, 1);
      this.instrumentMaterialNumber.splice(index, 1);
    }
  }

  public addReagentBatchField(){
    const reagentMaterialNumber = new FormControl('', [Validators.required]);
    const batchNumber = new FormControl('', [Validators.required]);

    reagentMaterialNumber.valueChanges.subscribe(() => {
      this.recalculateAllReagentBatchValues();
    });
    batchNumber.valueChanges.subscribe(() => {
      this.recalculateAllReagentBatchValues();
    });
    
    this.reagentMaterialBatchNumber.push({
      reagentMaterialNumber,
      batchNumber
    });
  }
  
  private recalculateAllReagentBatchValues() {
    this.reagentMaterialNo = [];
    this.materialBatchNo = [];
    
    for (let i = 0; i < this.reagentMaterialBatchNumber.length; i++) {
      const materialNumber = (this.reagentMaterialBatchNumber[i]?.reagentMaterialNumber?.value || "").toString().trim();
      const batchValue = (this.reagentMaterialBatchNumber[i]?.batchNumber?.value || "").toString().trim();

      if (materialNumber && batchValue) {
        const combinedKey = `${materialNumber}|${batchValue}`;
        this.materialBatchNo.push(combinedKey);
      } else if (materialNumber && !batchValue) {
        this.reagentMaterialNo.push(materialNumber);
      }
    }
    
    this.reagentMaterialNoValue = this.reagentMaterialNo.join(',');
    this.materialBatchNoValue = encodeURIComponent(this.materialBatchNo.join(','));
    this.requestEnabled = this.isRequestEnabled();
  }

  public removeReagentBatchField(index){
    if(this.reagentMaterialBatchNumber.length > 1){
      this.reagentMaterialBatchNumber.splice(index, 1);
      this.recalculateAllReagentBatchValues();
    }
  }

  public onReagentMaterialNoBatchNoValueChange(event: any, index: number) {
    this.recalculateAllReagentBatchValues();
  }

  public onShipmentPartnerRoleChange(): void {
    const selected = this.shipPartnerRoleFC.value || [];

    if (selected.length === this.allRoles.length) {
      this.shipPartnerRole = 'all';
    } else if (selected.length === 0) {
      this.shipPartnerRole = [];
    } else {
      this.shipPartnerRole = selected;
    }

    this.changeDetector.detectChanges();
  }

  public isPartnerRoleDisabled(option: string): boolean {
    return false;
  }

  public clearSelectedValue(clearValue){
      this.shipPartnerRoleFC.reset();
      this.shipPartnerRole = [];
  }

  public onDownload(): void {
    this.downloadVisible = true;
  }
  
  public onFormatSelected(format: string): void {
    this.downloadVisible = false;
    if (format === 'csv') {
      this.csvData();
    } else if (format === 'xlsx') {
      this.downloadExcel(this.selectedData, 'Notification Contacts');
    }
  }
  

  downloadExcel(data, filename) {
    const wb = XLSX.utils.book_new();
    const contacts = data.map((row, index) => {
      const { checked, ...rest } = row;
      return { 'S.No': index + 1, ...rest };
    });
    const ws = XLSX.utils.json_to_sheet(contacts);
    XLSX.utils.book_append_sheet(wb, ws, 'CONTACTS');
    
    // Download File
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    const blob = new Blob([this.stringToArrayBuffer(wbout)], { type: 'application/octet-stream' });

    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);

    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute('target', '_blank');
    }

    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.xlsx');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  stringToArrayBuffer(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }

  downloadCSV(data, filename, headerList) {
    let csvData = this.formatCSV(data, headerList);
    let blob = new Blob(['\uFEFF' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  formatCSV(objArray, headerList) {
    let str = '';
    str += headerList + '\r\n';

    for (let i = 0; i < objArray.length; i++) {
      let line = '';
      line += objArray[i] || '';
      str += line + '\r\n';
    }

    let res = '';
    res = 'SEP=,' + '\r\n' + str;

    return res;
  }

  csvData(){
    const contacts = this.selectedData.map((row, index) => {
      const { checked, ...rest } = row;
      return { 'S.No': index + 1, ...rest };
    });

    let headers = contacts.map((item) => Object.keys(item).toString());
    headers = Array.from(new Set(headers));
    
    const values = contacts.map((item) => {
      return Object.values(item).map(value => {
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          const escapedValue = value.replace(/"/g, '""');
          return `"${escapedValue}"`;
        }
        return value;
      }).join(',');
    });
    
    this.downloadCSV(values, 'Notification Contacts', headers);
  }

  public isAllSelected(){
  const selected = this.shipPartnerRoleFC.value || [];
  return selected.length === this.allRoles.length || selected.includes('all');
}

public selectedRolesDisplay(){
  if (this.isAllSelected()) {
    this.checked = true;
    return 'All';
  }
  return (this.shipPartnerRoleFC.value || []).map((v: string) => v.toUpperCase()).join(', ');
}


   snackBarMessage(status:any,message:string){
      snackbarService.show({
        message: message, 
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }
}